export enum EMethodsTypes {
  Whatsapp = 'WHATSAPP',
  Sms = 'SMS',
  Email = 'EMAIL',
}

export enum EErrorType {
  CODE_ALREADY_SENT = 'AUTH-025',
  INVALID_CODE = 'TFA-023',
}
